import { initializeIcons } from '@uifabric/icons';

let initFabricIconsHasBeenCalled: boolean = false;
export const hasInitFabricIconsBeenCalled = () => {
  return initFabricIconsHasBeenCalled;
};

export const initFabricIcons = () => {
  // If we try to init Fabric icons multiple times, it will error, hence the check to only do it once across the app.
  if (!hasInitFabricIconsBeenCalled()) {
    // initialize icons pointing to the trusted Sharepoint online CDN. This way it passed our Content-Security-Policy requirements.
    initializeIcons(
      'https://static2.sharepointonline.com/files/fabric/assets/icons/'
    );
    initFabricIconsHasBeenCalled = true;
  }
};
